import React, { useState, useEffect } from "react";
import qrcode from "qrcode";
import { Dialog, Grid, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";

import dynamicStyle from "./styles";

const FullScreenDialog = ({ open, setOpen, storeName, location }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const [qr, setQr] = useState("");

  useEffect(() => {
    generateQRCode(
      `https://bathroom.camclarkgroup.com/clean/?store=${storeName}&location=${location}`
    );
  }, [storeName, location]);

  const generateQRCode = (url) => {
    qrcode.toDataURL(
      url,
      {
        width: 1080,
        margin: 2,
      },
      (err, url) => {
        if (err) throw new Error(err);

        setQr(url);
      }
    );
  };

  const classes = dynamicStyle();

  console.log(location, storeName);

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullScreen>
        <Grid>
          <Button
            variant="contained"
            onClick={handleClose}
            style={{
              backgroundColor: "#ed342a",
              color: "white",
              fontSize: 15,
            }}
            sx={{ mt: 2, mx: 2 }}
            startIcon={<CloseIcon fontSize="small" />}
          >
            Close
          </Button>
          <Grid className={classes.qrCodeGrid}>
            <img style={{ width: 450 }} src={qr} alt="qrcode" />
          </Grid>
        </Grid>

        <Grid className={classes.downloadGrid}>
          <Button
            variant="contained"
            color="inherit"
            startIcon={<DownloadIcon />}
            href={qr}
            download="qrcode.jpeg"
          >
            Download QR Code
          </Button>
        </Grid>
      </Dialog>
    </>
  );
};

export default FullScreenDialog;
